import { render, staticRenderFns } from "./responsable-sg-editar.vue?vue&type=template&id=7865f550&scoped=true&"
import script from "./responsable-sg-editar.vue?vue&type=script&lang=js&"
export * from "./responsable-sg-editar.vue?vue&type=script&lang=js&"
import style0 from "./responsable-sg-editar.vue?vue&type=style&index=0&id=7865f550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865f550",
  null
  
)

export default component.exports